 <!-- Main Sidebar Container -->
 <aside class="main-sidebar sidebar-default elevation-4" style="background-color:white;">
    <!-- Brand Logo -->
<!--
    <a href="index3.html" class="brand-link">
      <img src="dist/img/my-champ.png" alt="AdminLTE Logo" class="brand-image   elevation-3" style="opacity: .8">
      <span class="brand-text font-weight-light" ></span>
    </a>
-->

    <!-- Sidebar -->
    <div class="sidebar" >
     
      <!-- Sidebar user panel (optional) -->
      <div class="user-panel mt-3  d-flex" >
        <a  style="display: none;float: right;right: 10px;position: absolute;" id="tglmenubar" class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="right fas fa-times "></i></a>
        <div class="image">
          <img src="assets/dist/img/no.jpg" class="img-circle elevation-2" alt="User Image">
        </div>
        <div class="info">
          <a routerLink="profile" class="d-block" >{{objusr.usrname}}</a>  
          <!-- <span style="color:red">{{objusr.class}}</span><br>
          <span style="color:green">{{objusr.crnm}}</span> -->
        </div>
        <!-- <div><span>{{objusr.class}}</span></div> -->
        
      </div>
     <div style="border-bottom:1px solid gray;"> <span style="color:red;text-align: center;display: block;align-items: center;">{{objusr.class}} ({{objusr.crnm}})</span>
      <!-- <span style="color:green;text-align: center;display: block;align-items: center;">{{objusr.crnm}}</span> -->
    </div>
     

      <!-- Sidebar Menu -->
      <nav class="mt-2">
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
          <!-- Add icons to the links using the .nav-icon class
               with font-awesome or any other icon font library -->
          <!-- <li class="nav-item menu-open">
            <a  class="nav-link active">
              <i class="nav-icon fas fa-tachometer-alt"></i>
              <p>
                Dashboard
                <i class="right fas fa-angle-left"></i>
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <a routerLink="/app/dash" class="nav-link ">
                  <i class="far fa-circle nav-icon"></i>
                  <p>Overview</p>
                </a>
              </li>
             
             
            </ul>
          </li> -->
          <li class="nav-item">
            <a routerLink="dash" class="nav-link">
              <i class="nav-icon fa fa-home"></i>
              <p>
            Home
              </p>
            </a>
          </li>
          
          <li class="nav-item">
            <a routerLink="profile" class="nav-link">
              <i class="nav-icon fa fa-user"></i>
              <p>
             My Profile 
              </p>
            </a>
          </li>
          <!-- <li class="nav-item">
            <a routerLink="gallery" class="nav-link">
              <i class="nav-icon fa fa-image"></i>
              <p>
              Gallery
              </p>
            </a>
          </li> -->
          <li class="nav-item">
            <a routerLink="notifications" class="nav-link">
              <i class="nav-icon fa fa-bell"></i>
              <p>
               Notifications
              </p>
            </a>
          </li>
          <li class="nav-item">
            <a routerLink="dairy" class="nav-link">
              <i class="nav-icon fa fa-book"></i>
              <p>
               Dairy Note
              </p>
            </a>
          </li>
          <li class="nav-item">
            <a routerLink="assesment" class="nav-link">
              <i class="nav-icon fa fa-chart-pie"></i>
              <p>
                Assessment
              </p>
            </a>
          </li>
          <li class="nav-item">
            <a routerLink="feedtls" class="nav-link">
              <i class="nav-icon fa fa-money-bill-alt"></i>
              <p>
               Fee Details
              </p>
            </a>
          </li>

          <li *ngIf="clcd=='105'" class="nav-item">
            <a routerLink="results" class="nav-link">
              <i class="nav-icon fa fa-book"></i>
              <p>
               Results
              </p>
            </a>
          </li>
          <!-- <li class="nav-item">
            <a routerLink="library" class="nav-link">
              <i class="nav-icon fa fa-table"></i>
              <p>
               Library
              </p>
            </a>
          </li> -->
          
          <!-- <li class="nav-item">
            <a routerLink="calendar" class="nav-link">
              <i class="nav-icon fa fa-calendar"></i>
              <p>
                Calendar
              </p>
            </a>
          </li> -->
          <!-- <li class="nav-item">
            <a routerLink="timetable" class="nav-link">
              <i class="nav-icon fa fa-clock"></i>
              <p>
                Timetable
              </p>
            </a>
          </li> -->
          <!-- <li class="nav-item">
            <a routerLink="downloads" class="nav-link">
              <i class="nav-icon fa fa-download"></i>
              <p>
                Download
              </p>
            </a>
          </li> -->
          
       
      
        
      
   
        </ul>
      </nav>
      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
  </aside>
